const cfosPages = ['fdr_cfos_transition', 'consumer_financial_outcomes']
const ARP = 'ARP'

export { cfosPages, ARP }
